import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { DTypeFormWeekDaysSelectionField } from '@grupo-constant/next-dtype/form';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { NgClass } from '@angular/common';
import { SelectOption } from '@grupo-constant/next-dtype/types';
import { firstValueFrom, map } from 'rxjs';
import { TranslocoPipe, TranslocoService } from '@ngneat/transloco';
import { LocalizePipe } from '../../../pipes/standalone/localize.pipe';
import { EnumsService } from '../../../enums/enums.service';
import { ClassesEnum } from '../../../enums/classes.enum';
import { WeekDaysEnum } from '../../../../modules/admin/projects/premises-management/premises.types';

@Component({
    selector: 'weekdays-field-component',
    templateUrl: './weekdays-field.component.html',
    imports: [LocalizePipe, NgClass, TranslocoPipe]
})
export class DtypeWeekDaysFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormWeekDaysSelectionField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    private enumsService = inject(EnumsService);
    private transloco = inject(TranslocoService);

    weekDaysOptions = signal<SelectOption[]>([]);

    async ngOnInit() {
        this.weekDaysOptions.set(await firstValueFrom(this.enumsService.retrieveEnumerationType(ClassesEnum.weekDays).pipe(map(reply => reply.option))));
    }

    toggleWeekDay(day: WeekDaysEnum) {
        let weekDays = (this.field.control.value ?? []) as WeekDaysEnum[];
        if (weekDays.includes(day)) {
            weekDays = weekDays.filter(d => d !== day);
        } else {
            weekDays = [...weekDays, day];
        }
        weekDays = weekDays.sort((a, b) => this.weekDaysOptions().findIndex(d => d.code === a) - this.weekDaysOptions().findIndex(d => d.code === b));
        this.field.control.setValue(weekDays);
    }

    weekDayIsSelected(day: WeekDaysEnum) {
        return ((this.field.control.value ?? []) as WeekDaysEnum[]).includes(day);
    }

    toSummaryView() {
        return this.field.control.value?.map(day => this.transloco.translate('weekdays.abbr_' + day)).join('');
    }
}

